import { RoutePath } from "./routePath";

/**
 * Path constants for wysh management and the wysh builder.
 */
export const RouteTemplates = {
  details: "/wyshes/:id/details",
  info: "/wyshes/:id/info",
  edit: "/wyshes/:id/edit/:field",
  editAccounts: "/wyshes/:allocationId/edit/accounts",
  updateHistory: "/wyshes/:allocationId/update-history",
} as const;

export const wyshesPaths = {
  wyshes: {
    root: "/wyshes",
    prioritize: "/wyshes/prioritize",
    details: RoutePath(RouteTemplates.details),
    info: RoutePath(RouteTemplates.info),
    edit: RoutePath(RouteTemplates.edit),
    editAccounts: RoutePath(RouteTemplates.editAccounts),
    updateHistory: RoutePath(RouteTemplates.updateHistory),
  },
  wyshBuilder: {
    root: "/wysh-builder",
    list: "/wysh-builder/list",
  },
};
